import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plan-dock-link",
  "use": "icon-plan-dock-link-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\" id=\"icon-plan-dock-link\">\r\n  <!-- 最上方的箭头尖端（进一步缩小） -->\r\n  <path d=\"M12 2 L14.5 5 L9.5 5 Z\" />\r\n\r\n  <!-- 中间的主干，向下延伸 -->\r\n  <path d=\"M11.5 5 H12.5 V20 H11.5 Z\" />\r\n\r\n  <!-- 左侧分叉：向下弯曲，连接左侧圆点 -->\r\n  <path d=\"M11.5 16 Q 4 16 4 12.5 L4 10.5 L5.4 10.5 L5.4 12.5 Q 5.4 14 11.5 14 Z\" />\r\n  <!-- 左侧圆点 -->\r\n  <circle cx=\"4.7\" cy=\"9\" r=\"1.6\" />\r\n\r\n  <!-- 右侧分叉：向上弯曲，连接右侧圆点 -->\r\n  <path d=\"M12.5 12.5 Q 20 12.5 20 9 L20 7 L18.6 7 L18.6 9 Q 18.6 10.5 12.5 10.5 Z\" />\r\n  <!-- 右侧圆点 -->\r\n  <circle cx=\"19.3\" cy=\"5.5\" r=\"1.6\" />\r\n\r\n  <!-- 底部的圆点节点 -->\r\n  <circle cx=\"12\" cy=\"20\" r=\"2\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/alarm/plan-dock-link.svg
// module id = f3gM
// module chunks = 24